<template>
  <BaseSimpleTab :tabs="tabs" />
  <div class='mt-5'>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'TheTaskInfoPage',
  data() {
    return {
      tabs: [
        {label: this.$t('global.general_information'), icon: 'info-square', routeName: 'settings_edit_tasks_route'},
        {label: this.$t('global.activities'), icon: 'file-alt', routeName: 'settings_task_activity_route'},
      ]
    }
  }
}
</script>

